module.exports = __webpack_public_path__ + "img/2f_r_bajitofu.748c1120.png";